import * as React from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import googleLogo from "../../../../Assets/Google.png";

interface SsoLoginSectionProps {
    onGoogleSignIn: () => void;
    disabled?: boolean;
    btnCtnClass: string;
    signInButtonClass: string;
    logoImgClass: string;
    dividerWrapperClass: string;
    orDividerLabelClass: string;
}

export const SsoLoginSection: React.FC<SsoLoginSectionProps> = ({
    onGoogleSignIn,
    disabled = false,
    btnCtnClass,
    signInButtonClass,
    logoImgClass,
    dividerWrapperClass,
    orDividerLabelClass,
}) => (
    <>
        <Grid item className={btnCtnClass}>
            <Button
                className={signInButtonClass}
                onClick={onGoogleSignIn}
                disabled={disabled}
                disableRipple
                disableElevation
            >
                <img src={googleLogo} className={logoImgClass} alt="Google" />{/**/}
                Google
            </Button>
        </Grid>

        <Grid item className={dividerWrapperClass}>
            <Divider>
                <Typography className={orDividerLabelClass}>OR</Typography>
            </Divider>
        </Grid>
    </>
);
